import { render, staticRenderFns } from "./OPACEbookreading.html?vue&type=template&id=58ab54f4&scoped=true&"
import script from "./OPACEbookreading.js?vue&type=script&lang=js&"
export * from "./OPACEbookreading.js?vue&type=script&lang=js&"
import style0 from "./OPACEbookreading.sass?vue&type=style&index=0&id=58ab54f4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab54f4",
  null
  
)

component.options.__file = "OPACEbookreading.vue"
export default component.exports